import { useParams } from "react-router";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { VisualAssessmentsTable } from "@/services/backend/htz/report/components/visual-assessments-table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";

export function VisualRoute() {
  const { reportId } = useParams();
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Visuelle Beurteilung")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die einzelnen visuellen Beurteilungen für die Bauteile angezeigt.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <VisualAssessmentsTable report={report!} />
      </CardContent>
    </Card>
  );
}
